import { ExternalLink } from 'lucide-react';
import NextLink from 'next/link';
import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function GalxeQuestTriggerFullDetails({ trigger }: Props) {
  const questId = useMemo(() => trigger.context?.quest_id, [trigger]);
  const questUrl = useMemo(() => (questId ? `https://app.galxe.com/quest/Recall/${questId}` : undefined), [questId]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow
        label="Executed with"
        value={
          <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
            <Text as="span" variant="body-sm" color="muted">
              Participants that completed quest
            </Text>
            {questId && questUrl && (
              <NextLink href={questUrl} target="_blank" className="tw:flex tw:gap-0.5 tw:no-underline">
                <Badge size="sm">
                  {questId}
                  <ExternalLink size={12} />
                </Badge>
              </NextLink>
            )}
          </div>
        }
      />
    </KeyValueTable>
  );
}
